module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.8984/img/templates-homepage/growth-analytics-icon.svg"